import { FolloweeCard } from "@/features/user/components/followee-card";
import { queries } from "@/utils/query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/user/$username/followers")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      queries.user.getFollowers.getFetchOptions({ userId: params.username }),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  const { username } = Route.useParams();
  const { data: followers } = queries.user.getFollowing.useSuspenseQuery({
    variables: {
      userId: username,
    },
  });

  return (
    <div>
      <div className="flex items-end">
        <h1 className="text-3xl">关注</h1>
        <span className="ml-4 text-2xl text-gray-fg-secondary">
          {followers.length}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-6 xl:grid-cols-3 2xl:grid-cols-4">
        {followers.map((follower) => (
          <FolloweeCard
            key={follower.userId}
            followee={follower}
            type="follower"
          />
        ))}
      </div>
    </div>
  );
}
